/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export abstract class BulkUpdateAbstractComponent {
  abstract dirty: boolean;

  abstract onSave(): void;

  protected resetDirty(value: boolean): void {
    this.dirty = value;
  }
}
